import { Component, OnInit, ViewChild, Input } from '@angular/core'; 
import { Router, ActivatedRoute } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationModalService } from '../../shared/components/modals/confirmation-modal/confirmation-modal.service';
import { MonthConversionFormComponent } from '../../shared/components/modals/month-conversion-modal/month-conversion-form.component';
import { BrandMonthConversionService } from '../../shared/services/brandMonthConversion.service';
import { BrandMonthConversion } from '../../shared/models/brandMonthConversion';
 
@Component({
  selector: 'app-month-conversions', 
  templateUrl: './month-conversions.component.html'
})

export class MonthConversionsComponent implements OnInit {  
  // MatPaginator Inputs
  length = 20;
  pageSize = 10;
  pageSizeOptions: number[] = [10, 25, 100];
  pageEvent: PageEvent;
  dataSource = new MatTableDataSource<BrandMonthConversion>();
  displayedColumns: string[] = ['actions', 'campaignType', 'range', 'convertMonth'];
  
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private brandMonthConversionService: BrandMonthConversionService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private notification: MatSnackBar,
    private confirmationModalService: ConfirmationModalService
  ) { }
   
  private _id; // private property _item

  // use getter setter to define the property
  get id(): any {
    return this._id;
  }

  @Input()
  set id(val: any) { 
    this._id = val; 
  } 

  // on load
  ngOnInit() {
    this.getRecords(this.id);
  }

  // get records
  getRecords(id: number): void {
    if (id > 0) {  
      this.brandMonthConversionService.getAll(id).subscribe(result => { 
          this.dataSource.data = result;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort; 

      }, error => console.error(error));
    }
  }

  // open add form 
  openAddModal() {
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(MonthConversionFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Add a Month Conversion';
    let model: BrandMonthConversion = {
      id: 0, brandId: this.id, campaignTypeId: 0, campaignTypeName: '', fromMonth: 0, toMonth: 0, convertMonth: 0
    };

    modalRef.componentInstance.inputModel = model;

    // modal result
    modalRef.result.then((result) => {
      if (result) {
        this.getRecords(this.id);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    ); 
  } 

  // delete item
  deleteItem(id: number) {

    this.confirmationModalService.confirm('Confirm', 'Are you sure you want to delete this item?')
      .then((confirmed) => {  
        if (confirmed) {
          this.brandMonthConversionService.delete(id).subscribe(() => {
              this.showNotification('The month conversion has been deleted successfully!', 'Okay!');
              this.getRecords(this.id);
            });
          }
        }
      )
      .catch(() =>
        console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
      ); 
  }

  //// edit item
  editItem(model: BrandMonthConversion) {

    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
    };

    const modalRef = this.modalService.open(MonthConversionFormComponent, modalOptions);
    modalRef.componentInstance.title = 'Edit Month Conversion';
    modalRef.componentInstance.inputModel = model;

    // modal result
    modalRef.result.then((result) => { 
      if (result) { 
        this.getRecords(this.id);
      }
    }).catch(() =>
      console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
    );  
  }
    
  // filter locations
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
   
  // show notification popup
  showNotification(msg: string, action: string) {
    this.notification.open(msg, action, { duration: 40000, panelClass: ['snackbar-success'] });
  }
   
}

